import { mapState } from 'vuex'
import httpClient from '../../api/httpClient'
import store from '../../store/store'
import vuetify from '../../plugins/vuetify'
export default {
  vuetify,
  data() {
    return {}
  },
  mounted() {},
  computed: {
    ...mapState('user', ['userDecoded']),
    ...mapState('colors', [
      'primaryColor',
      'secondaryColor',
      'navigationGradientColor',
      'navigationGradientSecondColor'
    ])
  },
  methods: {
    refreshColors() {
      let that = this
      if (this.userDecoded && this.userDecoded.TenantId) {
        httpClient
          .get(`/tenantSettings/${this.userDecoded.TenantId}`)
          .then(result => {
            let tenant = result.data
            if (tenant.primaryColor) {
              store.dispatch('colors/setPrimaryColor', tenant.primaryColor)
              that.$vuetify.theme.themes.light.primary = tenant.primaryColor
            }
            if (tenant.secondaryColor) {
              store.dispatch('colors/setSecondaryColor', tenant.secondaryColor)
              that.$vuetify.theme.themes.light.secondary = tenant.secondaryColor
            }
            if (tenant.navigationGradientColor) {
              store.dispatch(
                'colors/setNavigationGradientColor',
                tenant.navigationGradientColor
              )
            }
            if (tenant.navigationGradientSecondColor) {
              store.dispatch(
                'colors/setNavigationGradientSecondColor',
                tenant.navigationGradientSecondColor
              )
            }
          })
      }
    }
  }
}
